import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@sandtech-hub-monorepo/ui-kit';
import {
  HumanitarianStatus,
  HumanitarianStatusType,
} from '@sandtech-hub-monorepo/ehub-client';
import {
  HumanitarianStatusOptions,
  HumanitarianStatusTypeOptions,
  PDFFileUpload,
} from '@sandtech-hub-monorepo/ui-kit-site';
import { Control, UseFormWatch } from 'react-hook-form';

interface HumanitarianStatusFieldsProps {
  control: Control<any>;
  watch: UseFormWatch<any>;
  selectedFile?: File;
  onFileChange: (file: File | undefined) => void;
  showValidation?: boolean;
}

export const HumanitarianStatusFields = ({
  control,
  watch,
  selectedFile,
  onFileChange,
  showValidation = false,
}: HumanitarianStatusFieldsProps) => {
  return (
    <>
      <FormField
        control={control}
        name="humanitarianStatus"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm">
              Do you have a humanitarian status?
            </FormLabel>
            <Select
              onValueChange={field.onChange}
              value={(field.value as string) || undefined}
            >
              <FormControl>
                <SelectTrigger ref={field.ref}>
                  <SelectValue placeholder="Please select" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {Object.values(HumanitarianStatus).map((item) => (
                  <SelectItem value={item} key={item}>
                    {HumanitarianStatusOptions[item]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {showValidation && <FormMessage className="text-xs" />}
          </FormItem>
        )}
      />

      {watch('humanitarianStatus') === HumanitarianStatus.Yes && (
        <FormField
          control={control}
          name="humanitarianStatusType"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-sm">
                Type of humanitarian status
              </FormLabel>
              <Select
                onValueChange={field.onChange}
                value={(field.value as string) || undefined}
              >
                <FormControl>
                  <SelectTrigger ref={field.ref}>
                    <SelectValue placeholder="Please select" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent className="md:max-w-[618px]">
                  {Object.values(HumanitarianStatusType)
                    .filter((t) => t !== HumanitarianStatusType.NotAplicable)
                    .map((item) => (
                      <SelectItem value={item} key={item}>
                        {HumanitarianStatusTypeOptions[item]}
                      </SelectItem>
                    ))}
                </SelectContent>
              </Select>
              {showValidation && <FormMessage className="text-xs" />}
            </FormItem>
          )}
        />
      )}

      {watch('humanitarianStatusType') === HumanitarianStatusType.Refugee && (
        <div className="space-y-2">
          <Label className="text-sm">Refugee Card from UNHCR</Label>
          <PDFFileUpload value={selectedFile} onChange={onFileChange} />
        </div>
      )}
    </>
  );
};
